﻿const currentUser = {
  state: Object.assign(
    {},
    {
      isLoggedIn: false,
      timezone: {
        id: 'Pacific Standard Time',
        names: {
          generic: 'Pacific Time',
          standard: 'Pacific Standard Time',
          daylight: 'Pacific Daylight Time',
        },
        abbr: {
          generic: 'PT',
          standard: 'PST',
          daylight: 'PDT',
        },
        offset: '-08:00:00',
      },
      display: {
        temp: 0,
        units: 0,
      },
    },
    window.currentUser
  ),

  getters: {
    isMetric: (state) => {
      return state.display.units === 1;
    },
    isCelcius: (state) => {
      return state.display.temp === 1;
    },
  },

  mutations: {
    IS_METRIC(state, value) {
      state.display.units = value ? 1 : 0;
    },
    IS_CELCIUS(state, value) {
      state.display.temp = value ? 1 : 0;
    },
  },

  actions: {
    isMetric(context, value) {
      context.commit('IS_METRIC', value);
    },
    isCelcius(context, value) {
      context.commit('IS_CELCIUS', value);
    },
  },
};

export default currentUser



//////////////////
// WEBPACK FOOTER
// ./src/sections/store/currentUser.js
// module id = 78
// module chunks = 6 7 8